import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import DefaultLayout from "layouts/Default";
import {wrapper} from "lib/store";
import {getPaginatedServices, getServiceCategories} from "lib/services/product";
import {getDealsByProductCategory} from "lib/services/deals";
import {getBrandsByProductCategory} from "lib/services/brand";
import ProductListing from "components/views/ProductListing";
import React, {useEffect, useState} from "react";
import {getPaginatedBrandsThunk} from "lib/features/brandSlice";
import {useSelector, shallowEqual, useDispatch} from "react-redux";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {getPaginatedServicesThunk} from "lib/features/productSlice";

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
  const {
    query,locale,
  } = context
  const allDeals = await getDealsByProductCategory()
  const CATEGORIES = await getServiceCategories()

  const {
    page = 1,
    sort = {},
    deals = [],
    categories = [],
    brandVerified = false,
    brands = [],
    strainTypes = [],
    priceRanges = [],
    weights = [],
  } = query

  const filter = {
    deals,
    categories,
    brandVerified,
    brands,
    strainTypes,
    priceRanges,
    weights,
  }

  let businessTypes = []
  const brandFilter = {
    businessTypes
  }

  await store.dispatch(getPaginatedServicesThunk({page, filter, sort}))

  return {
    props: {
      allDeals,
      page,
      filter,
      sort,
      CATEGORIES,
      ...(await serverSideTranslations(locale, ['home', 'common']))

    }
  }
})

export default function CategorySlug(props) {
  const {
    page: _page,
    filter: _filter,
    sort: _sort,
    allDeals: deals,
    CATEGORIES,
  } = props

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loaded, setLoaded] = useState(false)
  const [localBrands, setLocalBrands] = useState([])
  let services = useSelector(state => state.product.services, shallowEqual)
  let brands = useSelector(state => state.brand.brands, shallowEqual)

  async function initBrand() {
    const sort = {}
    const page = 1
    const filter = {}
    await dispatch(getPaginatedBrandsThunk({page, filter, sort}))
  }
  useEffect(() => {
      console.log('at service listing: ', brands.length)
      if (brands[0].name === 'Test') {
        initBrand()
      } else {
        setLoaded(true)
        setLocalBrands(brands.slice(0,5))
      }
      return () => {
        console.log('clean up initBrand')
    }

  }, [brands])

  useEffect(() => {
    console.log('========== this is local brands: ', localBrands)
  }, [localBrands])



  return (
    <Wrapper>
      {loaded ?
          <Container>
            <ProductListing
                _filter={_filter} _page={_page} _sort={_sort}
                products={services} deals={deals} brands={localBrands}
                type={'Service'} categories={CATEGORIES}
                baseUrl={`/services/listing`}
            />
          </Container> :
          <Container style={{ marginTop: 50 }}>
            <span>{t('home:loading')}</span>
          </Container>
      }
    </Wrapper>
  )
}


CategorySlug.getLayout = function getLayout(page) {
  return (
    <DefaultLayout>
      {page}
    </DefaultLayout>
  )
}
